// @flow
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import urlUtil from 'app/common/lib/urlUtil';

// Navigates to a URL after the user logs in or logs out
export default function navigateAfterLoginStatusChange(nextUrl: string) {
  if (!urlUtil.isTrustedOrigin(nextUrl)) {
    nextUrl = '/';
    trackRegisterAction('url_reset');
  }
  changeWindowLocation(nextUrl, false);
}
